class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);

class HeaderSearch extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    this.input = this.querySelector('#HeaderSearchInput');
    this.resetButton = this.querySelector('#HeaderSearchReset');
    this.details = this.querySelector('details');
    this.summary = this.querySelector('summary');

    this.defaultInput = this.querySelector('#Search-In-Modal');
    this.input.addEventListener('input', (e) => {
      this.defaultInput.value = e.target.value;
      this.defaultInput.dispatchEvent(new Event('input', { bubbles: true }));
      if (this.input.value.length == 0) {
        // this.close();
      } else {
        this.open();
      }
    });
    this.input.addEventListener('focus', (e) => {
      this.defaultInput.value = e.target.value;
      this.defaultInput.dispatchEvent(new Event('input', { bubbles: true }));
      this.open();
    });
    this.form.addEventListener('reset', (e) => {
      this.close();
    });
    this.querySelector('.modal-overlay').addEventListener('click', (e) => {
      this.close();
    });
    this.querySelector('#close-search-drawer').addEventListener('click', (e) => {
      this.close();
    });
  }
  open() {
    this.resetButton.classList.remove('hidden');
    this.details.setAttribute('open', true);
  }
  close() {
    this.resetButton.classList.add('hidden');
    this.details.removeAttribute('open');
    this.querySelector('details-modal').close();
  }
}
customElements.define('header-search', HeaderSearch);
